import { FaExclamationTriangle } from 'react-icons/fa';

// Shown when a save would take a client past their monthly allocation. Admin only: the franchisee
// app refuses outright. Going ahead is recorded in the job's audit log.
const AllocationOverrideModal = ({ isOpen, breach, submitting, onConfirm, onCancel }) => {
  if (!isOpen || !breach) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h4 className="text-lg font-semibold mb-4 text-gray-800 flex items-center">
          <FaExclamationTriangle className="text-amber-500 mr-2" />
          Over Monthly Allocation
        </h4>

        <div className="text-sm text-amber-800 bg-amber-50 p-3 rounded border border-amber-300 space-y-1">
          <div className="flex justify-between"><span>Month</span><strong>{breach.monthYear}</strong></div>
          <div className="flex justify-between"><span>Allocation</span><strong>{breach.allocationHours}h</strong></div>
          <div className="flex justify-between"><span>Remaining before this job</span><strong>{breach.remainingHours}h</strong></div>
          <div className="flex justify-between"><span>Hours being saved</span><strong>{breach.proposedHours}h</strong></div>
          <div className="flex justify-between border-t border-amber-300 pt-1 mt-1">
            <span>Month would total</span><strong>{breach.totalAfterProposed}h</strong>
          </div>
        </div>

        {breach.usedBy?.length > 0 && (
          <div className="mt-3 text-sm text-gray-700">
            <p className="font-medium">Hours already used this month by:</p>
            <ul className="list-disc ml-5">
              {breach.usedBy.map(job => (
                <li key={job.jobId}>{job.date}: {job.hours}h <span className="text-gray-400 text-xs">({job.jobId})</span></li>
              ))}
            </ul>
          </div>
        )}

        <p className="mt-3 text-sm text-gray-700">
          Saving anyway will bill the supplier for more hours than this client is allocated.
          This override is recorded against the job.
        </p>

        <div className="flex justify-end space-x-3 mt-5">
          <button
            type="button"
            onClick={onCancel}
            disabled={submitting}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded-md shadow-sm hover:bg-gray-300 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={submitting}
            className="px-4 py-2 text-sm font-medium text-white bg-amber-500 border border-amber-600 rounded-md shadow-sm hover:bg-amber-600 disabled:opacity-50"
          >
            {submitting ? 'Saving…' : 'Save anyway'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllocationOverrideModal;
